import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';
import Throbber from '../components/throbber/Throbber';
import Error from '../components/error/Error';
import { useModal } from '../components/modal/useModal';
import CreateUserModal from '../components/users/CreateUserModal';
import EditUserModal from '../components/users/EditUserModal';
import DeleteUserModal from '../components/users/DeleteUserModal';
import { ReactComponent as BinSVG } from '../../img/icons/bin.svg';
import useUsers from '../hooks/useUsers';
import useAuth from '../useAuth';

const roleLabels = {
    admin: 'Admin',
    editor: 'Editor',
    viewer: 'Viewer',
};

const UsersView = () => {
    const { users, isLoading, isError } = useUsers();
    const { openModal } = useModal();
    const { claim } = useAuth();
    const currentEmail = claim?.email;

    const onCreate = (e) => {
        e.preventDefault();
        openModal(<CreateUserModal />);
    };

    const onEdit = (e, user) => {
        e.preventDefault();
        openModal(<EditUserModal user={user} />);
    };

    const onDelete = (e, user) => {
        e.preventDefault();
        openModal(<DeleteUserModal user={user} />);
    };

    return (
        <div className="view">
            <h1 className="heading">Users</h1>

            {isLoading ? (
                <Throbber title="Loading users" />
            ) : isError ? (
                <Error msg="Something went wrong loading users. Please try again later." />
            ) : users && users.length ? (
                <div className="users-table">
                    <div className="users-table__header">
                        <div className="users-table__col users-table__col--email">Email</div>
                        <div className="users-table__col users-table__col--role">Role</div>
                        <div className="users-table__col users-table__col--date">Created</div>
                        <div className="users-table__col users-table__col--actions"></div>
                    </div>
                    {users.map((user) => {
                        const isSelf = user.email === currentEmail;
                        return (
                            <div
                                className={`users-table__row ${!isSelf ? 'users-table__row--clickable' : ''}`}
                                key={user.id}
                                onClick={!isSelf ? (e) => onEdit(e, user) : undefined}
                            >
                                <div className="users-table__col users-table__col--email">
                                    {user.email}
                                    {isSelf && <span className="users-table__you">(you)</span>}
                                </div>
                                <div className="users-table__col users-table__col--role">
                                    {roleLabels[user.role] || user.role}
                                </div>
                                <div className="users-table__col users-table__col--date">
                                    {format(new Date(user.created_at), 'EEEEEE dd LLL yyyy, HH:mm', {
                                        locale: enUS,
                                    })}
                                </div>
                                <div className="users-table__col users-table__col--actions">
                                    {!isSelf && (
                                        <>
                                            <button className="button button--plain button--small button--icon" onClick={(e) => { e.stopPropagation(); onDelete(e, user); }}>
                                                <BinSVG />
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <p>No users found.</p>
            )}
            <button onClick={onCreate} className="button" style={{ marginTop: '1.5rem' }}>Add user</button>
        </div>
    );
};

export default UsersView;
